import {useEffect, useState} from "react";
import {addRemoveClassBody} from '../../utils'
import useWalletBalance from '../../hooks/useWalletBalance';

import { 
        HowToStartInfo, 
       } from '../../data/data-containers/HomeDemo1/data-HomeDemo1.js';

import dataTokenInfoUp from '../../data/data-containers/HomeDemo1/data-TokenInfoUp.json';
import dataTokenInfoDown from '../../data/data-containers/HomeDemo1/data-TokenInfoDown.json';
import RoadmapInfo from '../../data/data-containers/HomeDemo1/data-RoadmapInfo.json';
import FaqInfo from '../../data/data-containers/HomeDemo1/data-FaqInfo.json';
import dataContact from "../../data/data-containers/HomeDemo1/data-contact.json"
import IcoName from '../../data/data-layout/Footer/data-IcoName.json'
import TextFooter from '../../data/data-layout/Footer/data-TextFooter.json'


import { 
        HomeDemo1Faq,
        FooterPattern,
        FooterLogo,
        } from '../../utils/allImgs'

import Header from "../../layouts/Header"
import Footer from '../../layouts/Footer'

import SecHeroSection from '../../components/HeroSection' 
import SecToken from '../../components/SecToken' 
import Roadmap from '../../components/Roadmap'
import TokenInfo from '../../components/TokenInfo'
import HowToStart from '../../components/HowToStart'
import Faq from '../../components/Faq' 
import Subscribe from '../../components/Subscribe'

const HomeDemo1 = () => {

    const walletBalance = useWalletBalance();
    useEffect(() => {
      addRemoveClassBody('darker')
    },[])

    return (
      <div>
        <Header Title="XPLORADEX" />
        <SecHeroSection
          ClassSec="hero-section app section-padding"
          ColClass="col-12 col-lg-6 col-md-12"
          // specialHead="Crypto Trading With Lowest Commission"
          textUp="Experience AI-Driven Decentralized Trading on the XRP Ledger."
          textDown="Harness the power of artificial intelligence for smarter, faster, and more secure trading."
          link1="Buy XPL"
          link2="Join Telegram"
        />
       
        <div className="clearfix" />
        <HowToStart
          data={HowToStartInfo}
        />
      
        <SecToken
          conuterHeader="TOKEN SALE ENDS IN"
          percentage={((walletBalance /70000) * 100).toFixed(2)}
          
        />
        <Roadmap
          data={RoadmapInfo}
          ClassSpanTitle="roadmap section-padding-0-0"
        />
      
        <TokenInfo
          // img={HomeDemo1Dist}
          dataUp={dataTokenInfoUp}
          dataDown={dataTokenInfoDown}
        />
        <Faq
          ClassSpanTitle="faq-timeline-area section-padding-100-85"
          img={HomeDemo1Faq}
          data={FaqInfo}
        />
        {/* <OurTeam
          data={OurTeamInfo}
          ClassSec="our_team_area section-padding-0-0 clearfix"
        /> */}
        <Subscribe />
        <Footer
          FooterPattern={FooterPattern}
          FooterLogo={FooterLogo}
          text="At XploraDEX, our mission is to revolutionize decentralized trading by integrating cutting-edge AI technology with the robust infrastructure of the XRP Ledger."
          IcoName={IcoName}
          TextFooter={TextFooter}
          dataContact={dataContact}
        />
      </div>
    );
};

export default HomeDemo1